import merge from 'lodash/merge';

export default (chartParams, configsList) => configsList.reduce((prevConfig, configOrConfigFactory) => {
  const currentConfig = typeof configOrConfigFactory === 'function'
    ? configOrConfigFactory(chartParams)
    : configOrConfigFactory;
  return merge({}, prevConfig, currentConfig);
}, {});
